<template>
    <SettingsPage title="Profil">
        <div v-if="changePasswordMode">
            <h4>Passwort ändern</h4>

            <div class="auth-input-container">
                <b-form-group
                    id="fieldset-oldpassword"
                    label="Altes Passwort"
                    label-for="input-password"
                >
                    <b-form-input
                        id="input-oldpassword"
                        ref="oldpassword"
                        v-model="oldpassword"
                        v-validate="'required'"
                        name="oldpassword"
                        type="password"
                        placeholder="Bitte tragen Sie ihr altes Passwort ein"
                        :state="checkState('oldpassword')"
                    />
                </b-form-group>
            </div>
            <hr />
            <RepeatPassword v-model="password" />
            <div>
                <b-button @click="changePasswordMode = false">zurück</b-button>
                <b-button
                    variant="success"
                    :disabled="
                        errors.any() || !fieldIsDirty('oldpassword') || !fieldIsDirty('password')
                    "
                    @click="updatePassword()"
                >
                    Passwort ändern
                </b-button>
            </div>
        </div>
        <div v-else>
            <b-form-group
                id="fieldset-name"
                label="Benutzername"
                description="Hier können Sie Ihren Benutzernamen ändern"
                label-for="input-email"
            >
                <b-form-input
                    id="input-name"
                    v-model="username"
                    v-validate="'required'"
                    name="name"
                    type="text"
                    placeholder="Benutzername"
                    :state="checkState('name')"
                />
            </b-form-group>
            <b-form-group
                id="fieldset-email"
                label="E-Mail"
                description="Wenn Sie die Adresse ändern, erhalten Sie eine E-Mail, die Sie bestätigen müssen"
                label-for="input-email"
            >
                <b-form-input
                    id="input-email"
                    v-model="email"
                    v-validate="'required|email'"
                    name="email"
                    type="email"
                    placeholder="E-Mail Adresse"
                    :state="checkState('email')"
                />
            </b-form-group>
            <hr />
            <b-button variant="warning" @click="changePasswordMode = true">
                Passwort ändern
            </b-button>
            <hr />
            <b-button variant="success" @click="updateUser()">Änderungen speichern</b-button>
        </div>
    </SettingsPage>
</template>

<script>
import { UserAPI } from "@/store/api/Endpoints";
import RepeatPassword from "@/components/widgets/RepeatPassword";
import SettingsPage from "./SettingsPage";
export default {
    name: "UserProfileVue",
    components: { SettingsPage, RepeatPassword },
    data() {
        return {
            user: {
                email: this.$store.state.user.user_obj.email,
                username: this.$store.state.user.user_obj.username
            },
            changePasswordMode: false,
            password: null,
            oldpassword: null
        };
    },
    methods: {
        updateUser() {
            UserAPI.post("/account");
        },
        updatePassword() {}
    }
};
</script>
